<template>
  <el-container>
    <!-- 头部 -->
    <el-header>
      <v-header></v-header>
    </el-header>
    <!-- 主体区域 -->
    <router-view></router-view>
    <!-- 回到顶部 -->
    <scroll-top></scroll-top>
  </el-container>
</template>
<script>
import header from "@/components/header";
import ScrollTop from "@/components/ScrollTop";
export default {
  components: {
    "v-header": header,
    "scroll-top": ScrollTop
  },
  data() {
    return {};
  }
};
</script>

<style scoped lang="less">
.el-header {
  padding: 0;
  z-index: 9999;
}
</style>



// WEBPACK FOOTER //
// src/views/index.vue